import { useQuery } from '@tanstack/react-query';
import { getMap } from '~/api/projects2';

export const civilDrawMapQueryKey = (projectId: string, mapId: string) =>
  ['civilDrawMap', { projectId, mapId }] as const;

/** Loads a CivilDraw map with its map objects. */
export function useCivilDrawMap(projectId: string, mapId: string) {
  return useQuery({
    queryKey: civilDrawMapQueryKey(projectId, mapId),
    queryFn: () => getMap(projectId, mapId),
    // Don't automatically refetch - it would overwrite any unsaved edits
    staleTime: Infinity,
  });
}
